<template>
  <div style="display: contents">
    <v-card
      flat
      width="100%"
      height="100%"
      class="d-flex justify-center align-center"
      color="transparent"
    >
      <AuthForm
        :config="false"
        :welcome_theme="welcome_theme"
        :allow_webform="allow_webform"
        :range_status="range_status"
        :surveyInfo="surveyInfo"
      />
    </v-card>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import jwtDecode from "jwt-decode";
import AuthForm from "../../components/FormUI/AuthForm.vue";
export default {
  components: {
    AuthForm,
  },
  data() {
    return {
      surveyInfo: null,
      range_status: "",
      allow_webform: true,
      exist_form: {},
      welcome_theme: {
        bg_color: "#FBFBFBFF",
        bg_image: false,
        bg_image_url: "",
        bg_repeat: "repeat",
        bg_position_x: "left",
        bg_position_y: "top",
        bg_size: "auto",
        image: false,
        image_url:
          "https://chatme04.chatme.co.th/CMStorage/086672a7-dfa4-5ffc-b1fc-d5a148c0175b1643613845347.png",
        image_size: "100%",
        wc_fullwidth: false,
        wc_color: "#FFFFFFFF",
        wc_bg_title: "#FFFFFFFF",
        wc_title: "#395DA5FF",
        wc_subtitle: "#00000099",
        wc_justify: "start",
        default: {
          field_color: "#395DA5FF",
          field_bg: "#f0f0f0",
          field_label: "ชื่อผู้ทำแบบสอบถาม",
          field_dense: true,
          field_type: "outlined",
          button: {
            bg_color: "#395DA5FF",
            text: "เริ่มทำแบบสอบถาม",
            text_color: "#FFFFFFFF",
            bt_texttype: "button",
            bt_block: true,
            bt_rounded: true,
          },
        },
        notintime: {
          counting_color: "#F44336",
          counting_early_text: "แบบสอบถามนี้จะเปิดรับคำตอบในอีก",
          counting_early_color: "#000000",
          counting_end_text: "แบบสอบถามนี้หมดเวลารับคำตอบแล้ว",
          counting_end_color: "#F44336",
          text_justify: "center",
          swap_counting: false,
          swap_end: false,
        },
        oneid: {
          login_button: {
            bg_color: "#395DA5FF",
            text: "เข้าสู่ระบบผ่าน ONEID",
            text_color: "#FFFFFFFF",
            bt_texttype: "button",
            bt_block: true,
            bt_rounded: true,
          },
          showreg: true,
          showreg_btn: true,
          texttoreg: "คุณยังไม่มีบัญชี OneID ใช่หรือไม่ ?",
          texttoreg_color: "#00000099",
          reg_button: {
            bg_color: "#395DA5FF",
            text: "ลงทะเบียน OneID",
            text_color: "#395DA5FF",
            bt_texttype: "outlined",
            bt_block: true,
            bt_rounded: true,
          },
        },
        closed: {
          close_text: "แบบสอบถามนี้ปิดรับคำตอบแล้ว",
          close_text_color: "#F44336",
          text_justify: "center",
          swap_title: false,
        },
      },
    };
  },
  created() {
    this.getSurveyByID();
  },
  methods: {
    getSurveyByID() {
      this.$store
        .dispatch("getSurveyByID", this.$route.query.surveyID)
        .then((response) => {
          if (response.data.welcome_theme) {
            this.welcome_theme = response.data.welcome_theme;
          }
          document.getElementById("app").style.backgroundColor =
            this.welcome_theme.bg_color;
          document.getElementById("app").style.backgroundImage = this
            .welcome_theme.bg_image
            ? `url(${this.welcome_theme.bg_image_url})`
            : "";
          document.getElementById(
            "app"
          ).style.backgroundPosition = `${this.welcome_theme.bg_position_x} ${this.welcome_theme.bg_position_y}`;
          document.getElementById("app").style.backgroundRepeat =
            this.welcome_theme.bg_repeat;
          document.getElementById("app").style.backgroundSize =
            this.welcome_theme.bg_size;
          document
            .querySelector('meta[property="og:image"]')
            .setAttribute(
              "content",
              response.data.webform_theme.logo
                ? response.data.webform_theme.logo_image.url
                : "https://chatme04.chatme.co.th/CMStorage/surveylogo_1628216941416.png"
            );
          document
            .querySelector('meta[property="og:title"]')
            .setAttribute("content", response.data.surveyName);
          document
            .querySelector('meta[property="og:description"]')
            .setAttribute("content", response.data.surveyDetail);
          document
            .querySelector('meta[property="og:url"]')
            .setAttribute("content", window.location.href);
          const favicon = document.querySelector('link[rel~="icon"]');
          const favicon1 = document.querySelector('link[sizes="32x32"]');
          const favicon2 = document.querySelector('link[sizes="16x16"]');
          favicon.href = response.data.webform_theme.logo
            ? response.data.webform_theme.logo_image.url
            : "https://chatme04.chatme.co.th/CMStorage/surveylogo_1628216941416.png";
          favicon1.href = response.data.webform_theme.logo
            ? response.data.webform_theme.logo_image.url
            : "https://chatme04.chatme.co.th/CMStorage/surveylogo_1628216941416.png";
          favicon2.href = response.data.webform_theme.logo
            ? response.data.webform_theme.logo_image.url
            : "https://chatme04.chatme.co.th/CMStorage/surveylogo_1628216941416.png";
          document.title = response.data.surveyName;
          // console.log(response.data);
          this.surveyInfo = response.data;
          this.auth_require = response.data.enableAuth;
          if (this.surveyInfo.enableSchedule && this.surveyInfo.surveyStatus) {
            let now = new Date().getTime();
            let start = new Date(this.surveyInfo.surveyDatetimeStart).getTime();
            let end = new Date(this.surveyInfo.surveyDatetimeEnd).getTime();
            if (now < start) {
              this.allow_webform = false;
              this.range_status = "early";
            } else if (now > end) {
              this.allow_webform = false;
              this.range_status = "end";
            }
          }
          this.exist_form = response.data;
        })
        .catch((err) => {
          // console.log(err);
          Swal.fire({
            icon: "error",
            text:
              Object.keys(err.data).length === 0
                ? "ไม่พบแบบสอบถาม"
                : "ไม่สามารถดึงข้อมูล survey ได้",
            title: "",
          }).then(() => {
            if (this.$route.query.shared_token) {
              try {
                let jwtdata = jwtDecode(this.$route.query.shared_token);
                if (jwtdata.access_token) {
                  try {
                    let jwtdataonechat = jwtDecode(jwtdata.access_token);
                    this.CloseQuestion(jwtdataonechat);
                  } catch (error) {
                    console.log(error);
                  }
                } else {
                  this.CloseQuestion(jwtdata);
                }
              } catch (error) {
                console.log(error);
              }
            }
          });
        });
    },
    CloseQuestion(data) {
      let jwtdata = data;
      if (this.$route.query.socialType) {
        if (
          this.$route.query.socialType === "ONECHAT" &&
          this.$route.query.token &&
          this.$route.query.socialID
        ) {
          this.$axios.post(
            "https://chat-api.one.th/message/api/v2/disable_webview",
            {
              user_id: jwtdata.sub,
              bot_id: this.$route.query.socialID,
            },
            {
              headers: {
                Authorization: "Bearer " + this.$route.query.token,
              },
            }
          );
        } else if (
          this.$route.query.socialType === "ONEPLATFORM" &&
          this.$route.query.token
        ) {
          this.$axios.post(
            "https://platform.one.th/chat/api/v1/chatbot-api/close-web-view",
            {
              one_id: jwtdata.sub,
            },
            {
              headers: {
                Authorization: "Bearer " + this.$route.query.token,
              },
            }
          );
        } else if (this.$route.query.socialType === "FACEBOOK") {
          Swal.fire({
            html: "กดปุ่มขวาบนเพื่อปิดหน้าเว็บ",
            icon: "success",
            showCancelButton: false,
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            confirmButtonColor: "#0093cc",
            confirmButtonText: "รับทราบ",
          });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
